class FetchError {
  constructor(error) {
    this.error = error;
  }

  get status() {
    return this.error.response ? this.error.response.status : 0;
  }

  get message() {
    return this.error.response ? this.error.response.data : 0;
  }

  getErrorDescriptions() {
    const error = this.error;

    if (!navigator.onLine || !error.response)
      return navigator.onLine
        ? "پاسخی از سرور دریافت نشد"
        : "اتصال اینترنتی برقرار نیست";

    switch (error.response.status) {
      case 0:
        return "پاسخی از سرور دریافت نشد";
      case 400:
        return "درخواست شما معتبر نیست";
      case 401:
        return "توکن شما منقضی شده است";
      case 403:
        return "شما اجازه دسترسی به این قسمت را ندارید";
      case 404:
        return "خطای 404، چیزی یافت نشد";
      case 409:
        return "درخواست به دلیل تضاد با وضعیت فعلی منبع امکان پذیر نیست";
      case 500:
        return "بروز خطا در سمت سرور";
    }

    return "خطا در برقراری ارتباط با سرور";
  }

  // toastError(): void {
  //     toast(this.getErrorDescriptions());
  // }
}

export default FetchError;
